var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "push_switch" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "switch_box" },
      _vm._l(_vm.switchList, function (item) {
        return _c(
          "div",
          { key: item.key, staticClass: "switch_item" },
          [
            _c("img", {
              staticClass: "switch_logo",
              attrs: { src: item.icon, alt: "" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "switch_name" }, [
              _vm._v(_vm._s(item.name)),
            ]),
            _vm._v(" "),
            _c("el-switch", {
              attrs: { "active-value": 1, "inactive-value": 0 },
              on: {
                change: function ($event) {
                  return _vm.onChange(item, $event)
                },
              },
              model: {
                value: _vm.config[item.key],
                callback: function ($$v) {
                  _vm.$set(_vm.config, item.key, $$v)
                },
                expression: "config[item.key]",
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_title" }, [
      _vm._v("\n    推送平台开关\n    "),
      _c("span", { staticClass: "sub_text" }, [
        _vm._v("可实时控制对应平台的推送状态（建议开启）。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }